// src/components/admin/menu/AdminMenuEditForm.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import fetchData from '../../../api/fetchData'; 
import { useTranslation } from 'react-i18next';
import { supportedLngs } from '../../../i18n';

function AdminMenuEditForm() {
  const { menuItemId } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isEditMode = !!menuItemId;


  const [menuLink, setMenuLink] = useState('');
  const [currentTitle, setCurrentTitle] = useState('');
  const [editingLanguage, setEditingLanguage] = useState(i18n.language.split('-')[0] || 'ru');
  
  
  const [loading, setLoading] = useState(isEditMode);
  const [error, setError] = useState(null);
  const [saveStatus, setSaveStatus] = useState({ message: '', type: '' }); 
  const [isSaving, setIsSaving] = useState(false);

  
  const [menuItemData, setMenuItemData] = useState(null); 


  useEffect(() => {

    if (isEditMode) { 
      setLoading(true);
      setError(null);
      const loadMenuItemData = async () => {
        try {
          const response = await fetchData(`/admin/menu/admin_get_menu_item.php?id=${menuItemId}`, 'GET', null, { credentials: 'include' });
          
          if (response && response.status === 'success' && response.item) {
            const fetchedItem = response.item;
            setMenuItemData(fetchedItem); 
            setMenuLink(fetchedItem.menu_link || '');
            
          const langData = fetchedItem.translations?.[editingLanguage] || { title: '' };
          setCurrentTitle(langData.title || '');
          } else {
            setError(response?.message || 'Не удалось загрузить данные пункта меню.');
           
          }
        } catch (err) {
          setError(err.message);
          // setMenuItemData(null);
        } finally {
          setLoading(false);
        }
      };
      loadMenuItemData();
    } else { 
      setMenuItemData(null); 
      setMenuLink('');
      setCurrentTitle('');
      setEditingLanguage(i18n.language.split('-')[0] || 'ru');
      setLoading(false); 
      setError(null);
    }
  }, [menuItemId, isEditMode, editingLanguage]); 


  useEffect(() => {
    if (isEditMode && menuItemData && menuItemData.translations) {
      const langData = menuItemData.translations[editingLanguage] || { title: '' };
      setCurrentTitle(langData.title || '');
    }
  }, [editingLanguage, menuItemData, isEditMode]);

  const handleLanguageTabClick = (langCode) => {
    setEditingLanguage(langCode);
   if (isEditMode && menuItemData && menuItemData.translations) {
      const langData = menuItemData.translations[langCode] || { title: '' };
      setCurrentTitle(langData.title || '');
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setSaveStatus({ message: '', type: '' });

    const payload = {
      menuItemId: isEditMode ? menuItemId : null,
      language_code: editingLanguage,
      title: currentTitle,
      menu_link: menuLink // Непереводимое поле
    };
    
  try {
    // Вызываем PHP-скрипт для сохранения
    const response = await fetchData(
      `/admin/menu/admin_save_menu_item.php`, 
      'POST',
      payload,
      { credentials: 'include' }
    );

    if (response && response.status === 'success') {
      const messageToShow = t(response.messageKey, response.details);
      setSaveStatus({ message: messageToShow, type: 'success' });

   
      if (!isEditMode && response.newItemId) {
        setTimeout(() => {
          navigate(`/admin/menu/edit/${response.newItemId}`);
        }, 1500);
      }
    } else {
      const errorDetails = response?.message || 'Unknown error';
      setSaveStatus({ 
        message: t('admin.menu.saveErrorGeneric', { details: errorDetails }), 
        type: 'error' 
      });
    }
  } catch (err) {
    console.error("Ошибка при сохранении пункта меню:", err);
    setSaveStatus({ 
      message: t('messages.error.generic', { details: err.message }), 
      type: 'error' 
    });
  } finally {
    setIsSaving(false);
    setTimeout(() => setSaveStatus({ message: '', type: '' }), 5000);
  }
};


  if (loading && isEditMode) return <p>{t('messages.loading', 'Загрузка...')}</p>;
  if (error && isEditMode) return <p>{t('messages.error.generic', { details: error })}</p>;
  if (isEditMode && !menuItemData && !loading) return <p>{t('admin.menu.itemNotFound', 'Пункт меню не найден')}</p>;


return (
    <div className="admin-menu-edit-form">
        <h3>
        {isEditMode 
         ? t('admin.menu.editFormTitle', `Редактирование пункта меню ID: ${menuItemId}`) 
          : t('admin.menu.addFormTitle', 'Добавить новый пункт меню')}
         </h3>
         <div className="language-tabs">
            {/* <button onClick={() => handleLanguageTabClick('ru')} disabled={editingLanguage === 'ru'} className={editingLanguage === 'ru' ? 'active' : ''}>RU</button>

            <button onClick={() => handleLanguageTabClick('en')} disabled={editingLanguage === 'en'} className={editingLanguage === 'en' ? 'active' : ''}>EN</button> */}
                 {supportedLngs.map(langCode => (
        <button
          key={langCode}
          type="button"
          onClick={() => handleLanguageTabClick(langCode)}
          disabled={editingLanguage === langCode}
          className={editingLanguage === langCode ? 'active' : ''}
        >
          {langCode.toUpperCase()}
        </button>
      ))}
        </div>

        <form onSubmit={handleSave}>
            <fieldset>
                <legend>{t('admin.menu.linkLegend', 'Ссылка (не переводится)')}</legend>
                <div>
                    <label htmlFor="menuLink">{t('admin.menu.linkLabel', 'URL Ссылки')}:</label>
                    <input
                    type="text"
                    id="menuLink"
                    value={menuLink}
                    onChange={e => setMenuLink(e.target.value)} 
                    />
                </div>
            </fieldset>

            <fieldset>
                <legend>{t('admin.menu.translatableLegend', 'Переводимое Название для языка:')} {editingLanguage.toUpperCase()}</legend>
                <div>
                    <label htmlFor="currentTitle">{t('admin.menu.titleLabel', 'Название пункта')}:</label>
                    <input
                    type='text'
                    id='currentTitle'
                    value={currentTitle}
                    onChange={e => setCurrentTitle(e.target.value)}
                    />
                </div>
            </fieldset>

            <button type='submit' disabled={isSaving}>
                {isSaving
                 ? t('admin.buttons.saving', 'Сохранение...') 
                 : `${t('admin.buttons.save')} ${editingLanguage.toUpperCase()}`
            }
            </button>
        </form>

{saveStatus.message && (
     <p className={`form-status-message ${saveStatus.type === 'error' ? 'error' : 'success'}`}>
          {saveStatus.message}
     </p>
)}
 </div>
);
}

export default AdminMenuEditForm;